import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {RequestHistoricalData} from '../generated/model/request-historical-data';
import {Observable} from 'rxjs';

@Injectable()
export class HistoryService {

  constructor(private httpClient: HttpClient) {
  }

  getAllHistoricalData(): Observable<RequestHistoricalData[]> {
    return this.httpClient.get<RequestHistoricalData[]>(environment.baseUrlWs + '/api/history-request');
  }

}
